import "./i18n";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, useEffect, useState } from "react"; // Import useEffect

import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next"; // Import I18nextProvider
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "@/components/theme-provider";
import { createRoot } from "react-dom/client";
import { httpBatchLink } from "@trpc/client";
import i18n from "./i18n"; // Import the i18n instance
import { trpc } from "./lib/trpc";

function Root() {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: "/api/trpc",
        }),
      ],
    }),
  );

  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setCurrentLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  return (
    <StrictMode>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
            <I18nextProvider i18n={i18n}>
              <BrowserRouter>
                <App key={currentLanguage} />
              </BrowserRouter>
            </I18nextProvider>
          </ThemeProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </trpc.Provider>
    </StrictMode>
  );
}

const elem = document.getElementById("root");
if (!elem) {
  throw new Error("Root element #root not found in the document.");
}
const rootApp = <Root />;

if (import.meta.hot) {
  let root = import.meta.hot.data.root;
  if (!root) {
    root = createRoot(elem);
    import.meta.hot.data.root = root;
  }
  root.render(rootApp);
} else {
  createRoot(elem).render(rootApp);
}
